<template>
  <div class="c_table_wrap">
    <table>
      <colgroup>
        <col width="200px;">
        <col width="">
      </colgroup>
      <tr>
        <td class="c_t_title">카테고리</td>
        <td>
          <div>
            <el-select class="select curator_select" v-model="category"
                       @change="parentChange('category',category)">
              <el-option :value="''" :label="'선택'"></el-option>
              <el-option v-for="(data,index) in itemCategoryList" :key="`category${index}`" :value="data.node_id"
                         :label="data.NAME"></el-option>
            </el-select>
            <div class="input_error mt5">{{ validation.firstError('category') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">창작자/소유자</td>
        <td>
          <div>
            <el-button class="com_btn" @click="openModal()" v-if="!checkData('selectMember')">찾기</el-button>
            <el-tag v-else closable
                    @close="removeMember()">
              {{ selectMember.id }}
            </el-tag>
            <div class="input_error mt5">{{ validation.firstError('selectMember') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">컬렉션</td>
        <td>
          <div>
            <el-select class="select curator_select" v-model="collection"
                       @change="parentChange('collection',collection)">
              <el-option :value="''" :label="'선택'"></el-option>
              <el-option v-for="(data,index) in collectionList" :key="`category${index}`" :value="data.c_idx"
                         :label="data.c_title"></el-option>
            </el-select>
            <div class="input_error mt5">{{ validation.firstError('collection') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">업로드</td>
        <td>
          <div>
            <el-upload
                class="inline-block"
                action=""
                list-type="picture"
                :thumbnail-mode="true"
                :show-file-list="false"
                :auto-upload="false"
                :on-change="zipFileUpload"
                v-if="!checkData('zipFiles')"
            >
              <el-button class="com_btn">파일 업로드</el-button>
            </el-upload>
            <el-tag v-else closable
                    @close="removeZip()">
              {{ zipFiles[0].name }}
            </el-tag>
            <div class="input_error mt5">{{ validation.firstError('zipFiles') }}</div>
          </div>
        </td>
      </tr>

    </table>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import itemValidator from "@/mixins/validators/itemValidator";
import unZip from "@/components/item/lib/unZip";

export default {
  name: "ItemWriteAutoLayout",
  mixins: [imageOption, itemValidator, unZip],
  components: {},
  inject: ['itemWriteSetData'],
  provide() {
    return {}
  },
  props: {
    itemCategoryList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      files: [],
      zipFiles: [],
      imageArr: [],
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    EventBus.$on('setSelectMember', this.setSelectMember);
    EventBus.$on('ItemWriteAutoLayoutValidator', this.checkValidator);
  },
  beforeUpdate() {

  },
  beforeDestroy() {
    EventBus.$off('setSelectMember')
    EventBus.$off('ItemWriteAutoLayoutValidator')
  },
  destroyed() {
  },
  computed: {},
  methods: {
    checkValidator(dataArr) {
      this.$validate(dataArr)
    },
    parentChange(key, value) {
      this.itemWriteSetData(key, value)
    },
    checkData(data) {
      return !util.isEmpty(this[data]);
    },
    openModal() {
      this.$modal.show('item-auto-member-modal');
    },
    setSelectMember(data, list) {
      this.selectMember = data;
      this.collectionList = list;
      this.parentChange('selectMember', this.selectMember);
      this.parentChange('collectionList', this.collectionList);
    },
    removeMember() {
      this.selectMember = {}
      this.collectionList = []
      this.collection = ''
      this.parentChange('selectMember', this.selectMember);
      this.parentChange('collectionList', this.collectionList);
      this.parentChange('collection', this.collection);
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
